<template>
    <nav class="navbar navbar-expand-lg bg-primary" :class="classes" :color-on-scroll="alt ? 400 : null">
        <div class="container">
            <div class="navbar-translate">
                <router-link class="navbar-brand" to="/">Better Plastic Solutions</router-link>
                <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#example-navbar-primary" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-bar bar1"></span>
                    <span class="navbar-toggler-bar bar2"></span>
                    <span class="navbar-toggler-bar bar3"></span>
                </button>
            </div>
            <div class="collapse navbar-collapse justify-content-end" id="example-navbar-primary">
                <ul class="navbar-nav">
                    <router-link tag="li" to="/" class="nav-item" exact>
                        <a class="nav-link">
                            <i class="now-ui-icons users_circle-08"></i>
                            <p>About</p>
                        </a>
                    </router-link>
                    <router-link tag="li" to="/inventory" class="nav-item">
                        <a class="nav-link">
                            <i class="now-ui-icons ui-1_settings-gear-63"></i>
                            <p>Inventory</p>
                        </a>
                    </router-link>
                    <router-link tag="li" to="/contact" class="nav-item">
                        <a class="nav-link">
                            <i class="now-ui-icons ui-1_settings-gear-63"></i>
                            <p>Contact</p>
                        </a>
                    </router-link>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
  props: {
      alt: {
          type: Boolean,
          default: false,
      }
  },
  computed: {
      classes() {
          return {
              'navbar-transparent': this.alt,
              'fixed-top': this.alt,
          }
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Navbar.vue